import { Card } from "@mui/material";
import { FC, ReactNode, useState, useCallback } from "react";
import { NotificationDto } from "@/modules/notification-center/dtos";
import { useMarkSingleNotification } from "@/modules/notification-center/hooks/mark-single-notification.hook.ts";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface Props {
  notification: NotificationDto;
  children: ReactNode;
}

export const NotificationCard: FC<Props> = ({ children, notification }) => {
  const [clicked, setClicked] = useState(false);
  const { markSingleReadOrUnread } = useMarkSingleNotification();

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      if (!notification.link) return;
      const newTab = window.open(notification.link || "about:blank", "_blank");
      if (!notification.read) {
        markSingleReadOrUnread({ id: notification.id, read: true });
      }
      newTab?.focus();
      setClicked(true);
      setTimeout(() => setClicked(false), 200);
    },
    [notification, markSingleReadOrUnread]
  );

  return (
    <Card
      onClick={handleClick}
      sx={{
        cursor: notification.link ? "pointer" : "default",
        boxShadow: "none",
        borderRadius: 0,
        borderBottom: "1px solid #ccc",
        "&:last-child": { borderBottom: "none" },
        transition: "background-color 0.3s ease",
        backgroundColor: clicked
          ? nawyTheme.nawy.colors.semantic.layer.accentLight
          : "transparent",
        "&:hover": notification.link
          ? {
              backgroundColor: nawyTheme.nawy.colors.semantic.layer.accentLight,
              boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
            }
          : {},
      }}
    >
      {children}
    </Card>
  );
};
